import styled from 'styled-components';

export const IconWrapper = styled.span`
  padding-top: 0.12987em;
  padding-right: 1.5em;
`;
